import React, { useState } from 'react';
import './FAQAdminPanelStyles.css';

const FAQAdminPanel = () => {
  const [faqs, setFaqs] = useState([
    { question: 'What is Startup Connect?', answer: 'Startup Connect is a platform designed to ...' },
    { question: 'How do I register my startup on Startup Connect?', answer: 'To register, follow these steps: 1. Visit the re...' },
    { question: 'Who can use Startup Connect?', answer: 'Startups: Early-stage businesses looking ...' },
    { question: 'What are the benefits of DPIIT-recognized startups?', answer: 'DPIIT-recognized startups enjoy: - Tax exce...' },
    { question: 'Is there a fee for startups to join the platform?', answer: 'Basic registration on Startup Connect is free ...' },
    { question: 'How do investors connect with startups on the platform?', answer: 'Investors can browse startup profiles by indu...' },
    { question: 'How do investors connect with startups on the platform?', answer: 'Investors can browse startup profiles by indu...' },
  ]);

  const [newFAQ, setNewFAQ] = useState({ question: '', answer: '' });
  const [showForm, setShowForm] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFAQ({ ...newFAQ, [name]: value });
  };

  const handleAddFAQ = () => {
    if (newFAQ.question.trim() && newFAQ.answer.trim()) {
      setFaqs([...faqs, newFAQ]);
      setNewFAQ({ question: '', answer: '' });
      setShowForm(false);
    } else {
      alert('Please fill out both fields.');
    }
  };

  const handleDeleteFAQ = (indexToDelete) => {
    const updatedFaqs = faqs.filter((_, index) => index !== indexToDelete);
    setFaqs(updatedFaqs);
  };

  return (
    <div className="faq-admin-panel">
      <main className="content">
        <button className="create-faq-button" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Create FAQs'}
        </button>

        {showForm && (
          <div className="faq-form">
            <input
              type="text"
              name="question"
              placeholder="Enter question"
              value={newFAQ.question}
              onChange={handleInputChange}
              className="input-field"
            />
            <textarea
              name="answer"
              placeholder="Enter answer"
              value={newFAQ.answer}
              onChange={handleInputChange}
              className="input-field"
            />
            <button onClick={handleAddFAQ} className="update-button">
              Update
            </button>
          </div>
        )}

        <table className="faq-table">
          <thead>
            <tr>
              <th>Questions</th>
              <th>Answers</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {faqs.map((faq, index) => (
              <tr key={index}>
                <td>{faq.question}</td>
                <td>{faq.answer}</td>
                <td>
                  <button
                    className="delete-button"
                    onClick={() => handleDeleteFAQ(index)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </main>
    </div>
  );
};

export default FAQAdminPanel;
